// extracted by mini-css-extract-plugin
export default {"btnCadastrar":"BtnCadastrar_btnCadastrar__Rh8gH"};